import { GridColumnType } from "../../../../components/FinalMolGrid/libs/data/gridColumnType";
import { validationTypes } from "../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../components/forms/libs/data/formFieldType";


export const EmailTemplateDataConfig = {
    columns: [
        {
            name: "Email Name",
            fieldName: "emailName",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Email Subject",
            fieldName: "subject",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Email Project",
            fieldName: "projectName",
            allowShort: false,
            colType: GridColumnType.Text,

        },
        {
            name: "Email Where Used",
            fieldName: "whereUsed",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: true
            }
        },
    ],
};

export const AddEmailTempData = {
    name: "Add Email Temp",
    initialState: {
        emailName: null,
        subject: null,
        WhereUsed: null,
        projectType: null,
        description: null
    },
    section: [
        {
            title: "Add Email Temp",
            row: {},
            style: {
                sectionStyle: "row verticle-form",
            },
            rowGroup: [
                {
                    groupLabel: "Add Email Temp", // Group for contact fields
                    style: {
                        groupStyle: "col-lg-12 col-md-12 mb-2",
                    },
                    groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
                    fields: [
                        {
                            id: "emailName",
                            label: "Email Name",
                            Field_Name: "Email Name",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "emailName",
                            fieldSetting: {
                                placeholder: "Email Name",
                                allowSpace: true,
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-md-12 col-lg-6 mb-3"
                            }
                        },
                        {
                            id: "subject",
                            label: "Email Subject",
                            Field_Name: "Email Subject",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "subject",
                            fieldSetting: {
                                placeholder: "Email Subject",
                            },
                            style: {
                                containerCss: "col-md-12 col-lg-6 mb-3"
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                        },
                        {
                            id: "whereUsed",
                            label: "Email Where Use",
                            Field_Name: "Email Where Use",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "whereUsed",
                            fieldSetting: {
                                placeholder: "Email Where Use",
                            },
                            style: {
                                containerCss: "col-md-12 col-lg-6 mb-3"
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                        },
                        {
                            id: "projectType",
                            label: "Project",
                            Field_Name: "Project",
                            fieldType: FormFieldTypes.SELECT,
                            dataField: "projectType",
                            fieldSetting: {
                                placeholder: "Project",
                                options: []
                            },
                            style: {
                                containerCss: "col-md-12 col-lg-6 mb-3"
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                        },
                        {
                            id: "description",
                            label: "Template Description",
                            Field_Name: "Template Description",
                            fieldType: FormFieldTypes.TEXTEDITOR,
                            dataField: "description",
                            fieldSetting: {
                                allowSpace: true,
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-xxl-12 col-xl-12 col-md-12 col-12  mb-3",
                            },
                        },
                    ],
                },
            ],
        },
    ],
};

export const EditEmailTempData = {
    name: "Add Email Temp",
    initialState: {
        emailName: null,
        subject: null,
        WhereUsed: null,
        projectType: null,
        description: null
    },
    section: [
        {
            title: "Add Email Temp",
            row: {},
            style: {
                sectionStyle: "row verticle-form",
            },
            rowGroup: [
                {
                    groupLabel: "Add Email Temp", // Group for contact fields
                    style: {
                        groupStyle: "col-lg-12 col-md-12 mb-2",
                    },
                    groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
                    fields: [
                        {
                            id: "emailName",
                            label: "Email Name",
                            Field_Name: "emailName",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "emailName",
                            fieldSetting: {
                                placeholder: "Email Name",
                                allowSpace: true,
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-md-12 col-lg-6 mb-3"
                            }
                        },
                        {
                            id: "emailSubject",
                            label: "Email Subject",
                            Field_Name: "emailSubject",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "subject",
                            fieldSetting: {
                                placeholder: "Email Subject",
                            },
                            style: {
                                containerCss: "col-md-12 col-lg-6 mb-3"
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                        },
                        {
                            id: "emailWhereUse",
                            label: "Email Where Use",
                            Field_Name: "emailWhereUse",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "WhereUsed",
                            fieldSetting: {
                                placeholder: "Email Where Use",
                            },
                            style: {
                                containerCss: "col-md-12 col-lg-6 mb-3"
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                        },
                        {
                            id: "project",
                            label: "Project",
                            Field_Name: "project",
                            fieldType: FormFieldTypes.SELECT,
                            dataField: "projectType",
                            fieldSetting: {
                                placeholder: "Project",
                                options: []
                            },
                            style: {
                                containerCss: "col-md-12 col-lg-6 mb-3"
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                        },
                        {
                            id: "description",
                            label: "Template Description",
                            Field_Name: "Template Description",
                            fieldType: FormFieldTypes.TEXTEDITOR,
                            dataField: "description",
                            fieldSetting: {
                                allowSpace: true,
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-xxl-12 col-xl-12 ol-lg-12 col-md-12 col-12  mb-3 revert-style",
                            },
                        },
                    ],
                },
            ],
        },
    ],
};